import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { }
  
  scrollToFirstInvalidControl() {
    let firstInvalidControl = document.querySelector(
      '.ng-invalid[formControlName]'
    );
    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
      (firstInvalidControl as HTMLElement).focus();
    } else {
      setTimeout(() => {
        let firstInvalidClass = document.querySelector('.is-invalid');
        if (firstInvalidClass) {
          firstInvalidClass.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
          });
          (firstInvalidClass as HTMLElement).focus();
        }
      }, 10);
    }
  }
}
